export default __webpack_public_path__ + "static/media/dinner.8b09308f.svg";